export default function authModal() {
    return import(/* webpackChunkName: "AuthModal" */
    './index').then(mod => {
        return mod;
    });
}
